import * as React from 'react'
import ReactDOM from 'react-dom'

const cyberSourcePay = (url: string, data: PlainObject = {}) => {
    const divElement = document.getElementById('cyberSourcePay')
    ReactDOM.render(
        <form action={url} method="post">
            {
                Object.keys(data).map((item, index) =>
                    <input key={index} name={item} type="hidden" value={data[item]}/>
                )
            }
            <input type="submit"  value="Confirm" style={{display: 'none'}}/>
        </form>,
        divElement
    )
    const domNode: any = ReactDOM.findDOMNode(divElement)
    domNode.querySelector('form').submit()
    ReactDOM.unmountComponentAtNode(divElement)
}

export {cyberSourcePay}
